import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import fr from 'facet-rest';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { WizardLayout } from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'src/Helpers/Testing';

export const Layout = () => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();

  return (
    <LottieLoadingLayout>
      <WizardLayout
        aboveTitle={<LottieRel relationship={pageContentResource.relationship(fr.relationships.lottie.name)} height={200} />}
      >
        {pageContentResource.withRelationship(fr.relationships.navigate.name, (rel) => {
          const onClick = pageContentResource.withRelationship(fr.relationships.exit.name, (exitRel) => {
            return () => navigateByRelationship(exitRel, loadModalCollectionByLink, loadPageContentLink, clearModalCollection);
          }, () => undefined);

          return (
            <FDPrimaryActionButton
              href={rel.link('related').url()}
              label={rel.meta('prompt')}
              onClick={onClick}
            />
          );
        }, () => null)}

        {pageContentResource.withRelationship(fr.relationships.navigateInternal.name, (rel) => {
          const onClick = pageContentResource.withRelationship(fr.relationships.exit.name, (exitRel) => {
            return () => navigateByRelationship(exitRel, loadModalCollectionByLink, loadPageContentLink, clearModalCollection);
          }, () => undefined);

          return (
            <FDPrimaryActionButton
              {...dataAttrs('product-purchase-navigate-internal')}
              label={rel.meta('prompt')}
              onClick={onClick}
            />
          );
        }, () => null)}
      </WizardLayout>
    </LottieLoadingLayout>
  );
};
